import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7a21af16"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ul",
  ref: "after_sale_list"
};
const _hoisted_2 = {
  key: 1,
  class: "noorder"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "noimg"
}), /*#__PURE__*/_createElementVNode("p", null, "什么都没有哦")], -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  class: "evaluate-gift-wrap"
};
const _hoisted_7 = {
  class: "evaluate-gift-inner"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bg-img"
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "gift-notice"
}, "恭喜你，获得评价礼包", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_itemli = _resolveComponent("itemli");
  const _component_dialog_btn = _resolveComponent("dialog-btn");
  const _component_orderProjectRefund = _resolveComponent("orderProjectRefund");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [$data.list && $data.list.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.list, (item, index) => {
    return _openBlock(), _createBlock(_component_itemli, {
      key: item.order_id,
      item: item,
      listIndex: index,
      nav: 200,
      onGotoDetails: $options.gotoDetails,
      onOp: $options.op,
      onShow_dialog: $options.show_dialog
    }, null, 8, ["item", "listIndex", "onGotoDetails", "onOp", "onShow_dialog"]);
  }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))], 512), _createElementVNode("div", {
    class: "html",
    ref: "html",
    innerHTML: $data.html
  }, null, 8, _hoisted_5), _withDirectives(_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _hoisted_9, _createElementVNode("div", {
    class: "gift-confirm",
    onClick: _cache[0] || (_cache[0] = $event => $options.op({
      type: 'order_comment_add',
      item: $data.orderitem,
      orderType: $data.orderType
    }))
  }, " 立即评论 ")])], 512), [[_vShow, $data.giftWrapShow]]), _createVNode(_component_dialog_btn, {
    dialog_show: $data.dialog_show,
    onToParent: $options.close_dialog,
    dialog_btn: $data.dialog_btn,
    order_type: $data.order_type,
    list: true,
    onToOp: _cache[1] || (_cache[1] = e => {
      $data.dialog_show = false;
      $options.op({
        type: e,
        item: $data.orderitem,
        orderType: $data.orderType
      });
    })
  }, null, 8, ["dialog_show", "onToParent", "dialog_btn", "order_type"]), _createVNode(_component_dialog_btn, {
    dialog_show: $data.dialog_address,
    onToParent: _cache[2] || (_cache[2] = $event => $data.dialog_address = false),
    dialog_btn: $data.addressBtn,
    order_type: $data.order_type,
    list: true,
    onToOp: _cache[3] || (_cache[3] = e => _ctx.toAddress(e, $data.orderitem, $data.orderType))
  }, null, 8, ["dialog_show", "dialog_btn", "order_type"]), $data.refundInfo ? (_openBlock(), _createBlock(_component_orderProjectRefund, {
    key: 0,
    show: $data.orderProjectRefundShow,
    info: $data.refundInfo,
    onClosePopup: _cache[4] || (_cache[4] = $event => $data.orderProjectRefundShow = false),
    onGoNext: _ctx.goNext
  }, null, 8, ["show", "info", "onGoNext"])) : _createCommentVNode("", true)], 64);
}